import { forwardRef } from 'react';
import { NavLink as BaseNavLink, NavLinkProps } from 'react-router-dom';

export type OldNavLinkV5Props = NavLinkProps & { activeClassName: string };

// https://github.com/remix-run/react-router/releases?page=10#:~:text=You%20can%20always%20abstract%20over%20this%20feature%20in%20a%20custom%20NavLink%20if%20you%20prefer%20the%20old%20v5%20API
export const OldNavLinkV5 = forwardRef<HTMLAnchorElement, OldNavLinkV5Props>(
  (props, ref) => (
    <BaseNavLink
      ref={ref}
      to={props.to}
      className={({ isActive }) =>
        `${props.className} ${isActive ? props.activeClassName : ''}`
      }
    >
      {props.children}
    </BaseNavLink>
  )
);

OldNavLinkV5.displayName = 'OldNavLinkV5';
